import React from 'react';
import { Container } from '@chakra-ui/react';

import { Category } from '../components/Category';
import { useGetCollection } from '../hooks/useGetCollection';
import { repositoriesList2 } from '../helpers/repositoriesList';


export const Collections = () => {
    const { data, loadin, error } = useGetCollection("webcollections");
    console.log(data);

    if (loadin) {
        return <h2>Espere..</h2>
    }


    return (
        <Container className='animate__animated animate__fadeIn' maxW="7xl" p="5" mx="auto">
            {
                data.map((document) => (
                    <Category
                        key={document.category}
                        category={document.category}
                        webs={document.webs}
                    />
                ))
            }
        </Container>
    );
};

